import { render, staticRenderFns } from "./Physiology.vue?vue&type=template&id=b221164a&scoped=true&"
import script from "./Physiology.vue?vue&type=script&lang=js&"
export * from "./Physiology.vue?vue&type=script&lang=js&"
import style0 from "./Physiology.vue?vue&type=style&index=0&id=b221164a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b221164a",
  null
  
)

export default component.exports